import * as React from "react";
import {
  InputLabel,
  FormControl,
  createStyles,
  Theme,
  makeStyles,
  TextField,
} from "@material-ui/core";
import BaseFilter from "../../core/models/BaseFilter";
import { Autocomplete } from "@material-ui/lab";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "minWidth": 125,
      // "background": theme.palette.common.white,
      "margin": theme.spacing(0, 0.5),
      "margin-top": "-7px",

      "& legend": {
        maxWidth: 0,
      },

      "& .MuiOutlinedInput-input": {
        padding: theme.spacing(1, 4, 1, 1),
      },

      '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        height: "35px",
        background: theme.palette.common.white,
      },

      // replace default size of select
      "& .MuiInputLabel-outlined": {
        transform: "translate(0px, 4px) scale(0.75)",
        background: "transparent",
        borderTop: "unset",
      },

      // change background color on hover of native select option
      "& option:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
  })
);

type MaterialAutoCompleteProps = {
  filter: BaseFilter;
  classes?: Record<"root", string>;
  disabled?: boolean;
};

function MaterialAutoComplete(props: MaterialAutoCompleteProps) {
  const {
    value,
    handleChange,
    requestItems,
    items,
    id,
    label,
    variant,
    style,
    freeSolo,
    noOptionsText,
  } = props.filter;
  const disabled = props.disabled ?? false;

  const [isTyped, setIsTyped] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [typedValue, setTypedValue] = React.useState("");

  let classes = useStyles();

  if (props.classes) {
    classes = props.classes;
  }

  const onInputChange = (event: any, value: any, reason: string) => {
    if (reason === "input") {
      if (event) {
        if (requestItems) {
          setIsLoading(true);
          requestItems(value);
          setIsLoading(false);
        }
        setIsTyped(true);
        setTypedValue(value);
        event.preventDefault();
      }
    }
  };

  const onChange = (event: any, value: any, reason: string) => {
    const typed = value.value;
    setTypedValue(typed);
    setIsTyped(true);
    if (requestItems && isTyped) {
      requestItems("");
    }
    if (handleChange) {
      handleChange(event);
    }
  };

  const whichVariant = variant || "outlined";

  const allOptions = items.length > 0 ? [{ key: "all", value: "Todos" }, ...items] : [];

  const defaultValueFiltered = items.filter((x) => x.value == value);

  const defaultValue =
    defaultValueFiltered.length > 0 ? defaultValueFiltered[0] : { key: "", value: "" };

  return (
    <FormControl className={classes.root} variant={whichVariant}>
      <InputLabel id={`autocomplete-label-${id}-${label}`}>{label}</InputLabel>
      <Autocomplete
        id={id}
        freeSolo={freeSolo || false}
        noOptionsText={ noOptionsText ? noOptionsText : "Nenhuma opção encontrada"}
        onChange={onChange}
        disabled={disabled}
        autoComplete={false}
        value={isTyped ? { key: typedValue, value: typedValue } : defaultValue}
        filterOptions={(options, state) => options}
        getOptionLabel={(option: any) => option.value}
        getOptionSelected={(option, value) => option.value === value.value}
        onInputChange={onInputChange}
        options={allOptions}
        loading={isLoading}
        style={style}
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            margin="normal"
            size="small"
            variant={whichVariant}
            value={value}
            style={style}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
}

export default MaterialAutoComplete;
